import { jsx } from "react/jsx-runtime";
const ChevronDown = (props) => {
  return /* @__PURE__ */ jsx(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      width: "8",
      height: "6",
      fill: "none",
      viewBox: "0 0 8 6",
      ...props,
      children: /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#CAD0DC",
          d: "M7.414 1.407L4.51 5.212a.597.597 0 01-1.022 0L.586 1.407A.599.599 0 011.096.5h5.807a.596.596 0 01.51.907z"
        }
      )
    }
  );
};
export {
  ChevronDown as default
};
